import type { ReactNode } from 'react'

interface HomeAlertStripProps {
  children: ReactNode
}

export function HomeAlertStrip({ children }: HomeAlertStripProps) {
  return <div className="home-alert-strip">{children}</div>
}
